var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyLink = function SvgCopyLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 13.3307H5.0013C3.16047 13.3307 1.66797 11.8382 1.66797 9.9974V4.9974C1.66797 3.15656 3.16047 1.66406 5.0013 1.66406H10.0013C11.8421 1.66406 13.3346 3.15656 13.3346 4.9974V9.9974C13.3346 11.8382 11.8421 13.3307 10.0013 13.3307Z",
    fill: "#D2D2D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0013 18.3307H10.0013C8.16047 18.3307 6.66797 16.8382 6.66797 14.9974V9.9974C6.66797 8.15656 8.16047 6.66406 10.0013 6.66406H15.0013C16.8421 6.66406 18.3346 8.15656 18.3346 9.9974V14.9974C18.3346 16.8382 16.8421 18.3307 15.0013 18.3307Z",
    fill: "#828282"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "copy-link.1bfd4d24e5873082984c0b7675415ae5.svg";